import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {useDispatch} from 'react-redux';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';

import {TypedDispatch} from 'shared/model/types';
import {isTranslate} from 'shared/lib/lang';

import {fetchMe} from '../../model/thunks/fetchMe';
import {userAPI} from '../../api/userAPI';

import styles from './SubscribeModal.module.scss';

interface ISubscribeModalProps {
    isOpen: boolean;
    // eslint-disable-next-line no-unused-vars
    onClose: (responded: boolean) => void;
    userId?: number;
}

const SubscribeModal: React.FC<ISubscribeModalProps> = ({isOpen, onClose, userId}) => {
    const dispatch = useDispatch<TypedDispatch>();
    const [changeConsent] = userAPI.useChangeUserNewsletterConsentMutation();

    const handleResponse = async(agreeToNewsletter: boolean) => {
        if (!userId) return;
        try {
            await changeConsent({id: userId, agreeToNewsletter}).unwrap();
            await dispatch(fetchMe());
            onClose(true);
        } catch (error) {
            onClose(false);
        }
    };

    const handleAccept = () => handleResponse(true);
    const handleDecline = () => handleResponse(false);
    const handleClose = () => onClose(false);

    return (
        <MainModal
            header=""
            open={isOpen}
            handleClose={handleClose}
            size="md"
            dialogClassName={styles.background}
        >
            <ModalBodyWrapper>
                <div className={styles.container}>
                    <p className={styles.text}>
                        {t`Хотите получать важные уведомления, специальные предложения и новости от Overseer?`}
                    </p>
                    {
                        !isTranslate() && <a
                            href={AppUrls.SUBSCRIPTION}
                            className={styles.link}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t`Согласие на рассылку`}
                        </a>
                    }
                </div>
            </ModalBodyWrapper>
            <ModalBlockButton
                primaryButtonText={t`Да`}
                primaryButtonOnClick={handleAccept}
                secondaryButtonOnClick={handleDecline}
                secondaryButtonText={t`Нет`}
            />
        </MainModal>
    );
};

export default SubscribeModal;